import Datapoint from 'owa-service/lib/contract/Datapoint';
import DatapointConsumer from 'owa-service/lib/contract/DatapointConsumer';
import logDatapointOperation from 'owa-service/lib/operation/logDatapointOperation';

export interface FeedbackRibbonLogDataPointProps {
    SessionId: string;
    Feature: string;
    SubFeature: string;
    RibbonResponse: string;
    MetaData: string;
}

export function sendFeedbackRibbonDatapoint(
    datapointProps: FeedbackRibbonLogDataPointProps
): Promise<boolean> {
    const keys: string[] = ['frsid', 'frf', 'frsf', 'frrr', 'frmd'];

    let values: string[] = [
        datapointProps.SessionId,
        datapointProps.Feature,
        datapointProps.SubFeature,
        datapointProps.RibbonResponse,
        datapointProps.MetaData,
    ];

    let feedbackLogDatapoint: Datapoint = {
        Id: 'FeedbackRibbon',
        Consumers: DatapointConsumer.Analytics,
        Time: new Date(Date.now()).toString(),
        Keys: keys,
        Values: values,
    };

    return logDatapointOperation({ datapoints: [feedbackLogDatapoint] });
}
